export function asMapV<T, K, V>(arr: Array<T>, keyFunc: ((t: T) => K), valueFunc: ((t: T) => V)) {
  const map = new Map<K, V>();
  arr.forEach((t: T) => {
    const key: K = keyFunc(t);
    const value: V = valueFunc(t);
    map.set(key, value);
  });
  return map;
}

export function asMap<K, V>(arr: Array<V>, keyFunc: ((v: V) => K)) {
  return asMapV<V, K, V>(arr, keyFunc, v => v);
}
